module.exports = __webpack_public_path__ + "img/7_Hepatic--Flexure.43403141.png";